import { CommonModuleInner, SectionSubtitle, SectionTitle } from '@/sem/styles';
import type { SemFeaturesModule } from '~/contracts/sem';
import { FeatureCard, GridWrapper } from './ShopByFeature.styles';
import SemTrackWrapper from '../SemTrackWrapper';

type OwnProps = Omit<SemFeaturesModule, '__typename'>;

function ShopByFeatures({ id, subtitle, title, items }: OwnProps) {
  return id && items ? (
    <SemTrackWrapper sectionName="Shop By Features">
      <CommonModuleInner>
        <div className="flex flex-col gap-8 self-start">
          {title && <SectionTitle>{title}</SectionTitle>}
          {subtitle && <SectionSubtitle>{subtitle}</SectionSubtitle>}
        </div>

        <GridWrapper>
          {items.map(item =>
            item.slug ? (
              <a
                href={item.slug}
                key={item.title}
                className="inline-block !w-full no-underline"
                data-analytics-id="Shop By Features - Feature Item"
                data-analytics-attributes={JSON.stringify({
                  title: item.title,
                  linkUrl: item.slug
                })}
              >
                <FeatureCard>
                  <div className="text-blue-6 tl-body-m">{item.title}</div>
                </FeatureCard>
              </a>
            ) : null
          )}
        </GridWrapper>
      </CommonModuleInner>
    </SemTrackWrapper>
  ) : null;
}

export default ShopByFeatures;
